"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelTooltip = function LabelTooltip(_ref) {
  var tooltip = _ref.tooltip;
  return _react.default.createElement(_Tooltip.default, {
    title: _react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: tooltip
      }
    })
  }, _react.default.createElement("svg", {
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "MuiSvgIcon-root jss180",
    style: {
      fontSize: '1rem'
    }
  }, _react.default.createElement("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  })));
};

var Label = function Label(_ref2) {
  var customLabel = _ref2.customLabel,
      tooltip = _ref2.tooltip,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? '' : _ref2$margin,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  return _react.default.createElement(_InputLabel.default, {
    style: {
      display: "flex",
      gap: "0.3rem",
      alignItems: "center",
      lineHeight: "1.5",
      cursor: disabled ? "not-allowed" : "normal",
      margin: margin ? margin : tooltip ? "2px 0" : "auto"
    }
  }, customLabel, tooltip && _react.default.createElement(LabelTooltip, {
    tooltip: tooltip
  }));
};

var _default = _react.default.memo(Label);

exports.default = _default;